// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2tXA2","col":"styles_col__cHcw9","fulfillmentStatus":"styles_fulfillmentStatus__iErpI","emailCol":"styles_emailCol__3SPHF"};